package devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentProcess

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.pages.dashboard.softwareDevelopmentSection.SoftwareColumn
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun AiDevelopmentProcess(breakpoint: Breakpoint, sitePalette: SitePalette){
    Column (modifier = Modifier.fillMaxWidth()){
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(sitePalette.softwareSectionBackground.rgb),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier.fillMaxWidth()
                    .padding( top= 40.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    text = "Proven Approach ",
                    modifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.Medium)
                        .lineHeight(15.4.px)
                        .textTransform(TextTransform.Uppercase)
                        .padding(bottom = 5.px)
                )
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    val rowTextModifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontWeight(FontWeight.ExtraBold)
                        .textTransform(TextTransform.Uppercase)
                    Row(
                        modifier = Modifier.flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(
                            text = "Our ",
                            modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                        )
                        SpanText(
                            text = "AI ",
                            modifier = rowTextModifier.color(sitePalette.primary.rgb)
                        )
                        SpanText(
                            text = "DEVELOPMENT",
                            modifier = rowTextModifier.color(sitePalette.primary.rgb)
                        )
                        if (breakpoint >= Breakpoint.MD) {
                            SpanText(
                                text = " PROCESS",
                                modifier = rowTextModifier.color(sitePalette.primary.rgb)
                            )
                        }
                    }
                    if (breakpoint < Breakpoint.MD){
                        SpanText(
                            text = " PROCESS",
                            modifier = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(18.px)
                                .color(sitePalette.primary.rgb)
                                .fontWeight(FontWeight.ExtraBold)
                        )
                    }
                }
// Row for columns
                if(window.screen.width in 960..1439){
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 100.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                    ) {
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.dataBaseLogo,
                            number = "01", title = "Data Collection and preparation",
                            description = "In the AI development process, data collection is the foundation." +
                                    " It involves gathering relevant datasets that will be used to train " +
                                    "the AI model. Data must be cleaned, preprocessed, and " +
                                    "structured to ensure its quality and usability.",
                            downArrow = true)
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.modelDesign,
                            number = "02", title = "Model Design and Training",
                            description = "This phase focuses on designing the AI model architecture. Developers select algorithms and techniques suitable for the task at hand. Training involves feeding the model with the prepared data, allowing it to learn patterns and make predictions.",
                            downArrow = true
                        )
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 10.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                    ) {
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.evaluation_logo,
                            number = "03", title = "Evaluation and Optimization",
                            description = "After training, the model’s performance is evaluated using various metrics. Developers identify areas of improvement and fine-tune the model by adjusting parameters, algorithms, or data inputs to enhance accuracy and efficiency."
                        )
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                            number = "04", title = "Deployment",
                            description = "Once the AI model meets desired performance criteria, it’s deployed in a real-world environment. Continuous monitoring is crucial to ensure it functions correctly. Regular updates and maintenance are performed as needed to keep the AI system robust and reliable."
                        )
                    }

                }
                else{
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 100.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.Center,
                    ) {
                        val imagelineModifier = Modifier
                            .width(120.px)
                            .border(1.px)
                            .margin(left = (-20).px, top = 50.px)

                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.dataBaseLogo,
                            number = "01", title = "Data Collection and preparation",
                            description = "In the AI development process, data collection is the foundation. It involves gathering relevant datasets that will be used to train the AI model. Data must be cleaned, preprocessed, and structured to ensure its quality and usability.",
                            downArrow = breakpoint <= Breakpoint.LG,

                            )
                        if(breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                        }
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.modelDesign,
                            number = "02", title = "Model Design and Training",
                            description = "This phase focuses on designing the AI model architecture." +
                                    " Developers select algorithms and techniques suitable for the task" +
                                    " at hand. Training involves feeding the model with the prepared data," +
                                    " allowing it to learn patterns and make predictions.",
                            downArrow = breakpoint <= Breakpoint.LG,
                            minusLeft = true
                        )
                        if (breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                        }

                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.evaluation_logo,
                            number = "03", title = "Evaluation and Optimization",
                            description = "After training, the model’s performance is evaluated using various metrics. Developers identify areas of improvement and fine-tune the model by adjusting parameters, algorithms, or data inputs to enhance accuracy and efficiency.",
                            downArrow = breakpoint < Breakpoint.MD,
                            minusLeft = true
                        )
                        if (breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                        }
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                            number = "04", title = "Deployment",
                            description = "Once the AI model meets desired performance criteria, it’s deployed in a real-world environment. Continuous monitoring is crucial to ensure it functions correctly. Regular updates and maintenance are performed as needed to keep the AI system robust and reliable.",
                            minusLeft = true

                        )
                    }
                }

            }
        }
    }
}